import React, { useState, useRef, useEffect } from 'react';

export default function SearchableDropdown({
  options = [],
  value,
  onChange,
  placeholder = 'Search…',
  displayKey = 'label',
  valueKey = 'value',
  disabled = false,
  emptyMessage = 'No options found',
}) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const selected = options.find((o) => o[valueKey] === value);
  const filtered = options.filter((o) =>
    String(o[displayKey] || '').toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    const handleClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    if (selected) setQuery(selected[displayKey] || '');
  }, [selected, displayKey]);

  return (
    <div className="ui-search-dropdown" ref={wrapRef}>
      <input
        type="text"
        value={query}
        onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={disabled}
      />
      {open && !disabled && (
        <ul className="ui-search-dropdown-list">
          {filtered.length === 0 ? (
            <li className="ui-search-dropdown-empty">{emptyMessage}</li>
          ) : (
            filtered.map((opt) => (
              <li
                key={opt[valueKey]}
                className={opt[valueKey] === value ? 'is-selected' : ''}
                onMouseDown={() => {
                  onChange(opt[valueKey], opt);
                  setQuery(opt[displayKey]);
                  setOpen(false);
                }}
              >
                {opt[displayKey]}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
}
